import ReportMachineProperty from "./ReportMachineProperty";
export default ReportMachineProperty;